'use strict';
const emptyShadowImg = new Image(),
	px = require('../dom/px'),
	createDragHandle = function (nodeDOM) {
		const result = nodeDOM.ownerDocument.createElement('div');
		result.classList.add('resize-node');
		result.setAttribute('draggable', 'true');
		return result;
	};

emptyShadowImg.src = 'data:image/gif;base64,R0lGODlhAQABAIAAAAUEBAAAACwAAAAAAQABAAACAkQBADs=';

module.exports = function nodeResizeWidget(nodeDOM, nodeId, mapModel, stage) {
	let initialWidth,
		initialStyle,
		dragStartX,
		currentX;
	const minAllowedWidth = 10,
		nodeTextDOM = nodeDOM.querySelector('span[data-mapjs-role=title]'),

		calcDragWidth = function () {
			const dx = (Number.isFinite(currentX) && Number.isFinite(dragStartX) && (currentX - dragStartX)) || 0,
				dragWidth = dx && Math.max(minAllowedWidth, (initialWidth + dx));
			return dragWidth;
		},
		dragHandleDOM = createDragHandle(nodeDOM),
		onDragOver = e => {
			currentX = stage.stagePositionForPointEvent(e).x;
			e.dataTransfer.dropEffect = 'move';
			e.preventDefault();
		};

	dragHandleDOM.addEventListener('dragstart', function (evt) {
		evt.stopPropagation();
		if (!mapModel.isEditingEnabled()) {
			return;
		}
		dragHandleDOM.classList.add('resizing');
		mapModel.selectNode(nodeId);
		initialWidth = nodeTextDOM.offsetWidth;
		initialStyle = {
			'node.min-width': nodeDOM.style.minWidth,
			'span.min-width': nodeTextDOM.style.minWidth,
			'span.max-width': nodeTextDOM.style.maxWidth
		};
		dragStartX = stage.stagePositionForPointEvent(evt).x;
		evt.dataTransfer.setDragImage(emptyShadowImg, 0, 0);
		stage.getDOMElement().addEventListener('dragover', onDragOver);
	});
	dragHandleDOM.addEventListener('dragend', function (evt) {
		evt.stopPropagation();
		evt.preventDefault();
		if (!mapModel.isEditingEnabled()) {
			return;
		}
		const dragWidth = nodeTextDOM.offsetWidth;
		dragHandleDOM.classList.remove('resizing');
		nodeTextDOM.style.maxWidth = initialStyle['span.max-width'];
		nodeTextDOM.style.minWidth = initialStyle['span.min-width'];
		nodeDOM.style.minWidth = initialStyle['node.min-width'];
		mapModel.setNodeWidth('mouse', nodeId, dragWidth);
		stage.getDOMElement().removeEventListener('dragover', onDragOver);
	});
	dragHandleDOM.addEventListener('drag', function (evt) {
		evt.stopPropagation();
		evt.preventDefault();
		if (!mapModel.isEditingEnabled()) {
			return;
		}
		const dragWidth = calcDragWidth(),
			scale = stage.getStageData().scale;
		if (dragWidth) {
			nodeTextDOM.style.maxWidth = px(dragWidth);
			nodeTextDOM.style.minWidth = px(dragWidth);
			nodeDOM.style.minWidth = px(nodeTextDOM.getBoundingClientRect().width / scale);
			const newMinimumContentWidth = nodeTextDOM.scrollWidth;
			if (newMinimumContentWidth > nodeTextDOM.offsetWidth) {
				nodeTextDOM.style.maxWidth = px(newMinimumContentWidth);
				nodeTextDOM.style.minWidth = px(newMinimumContentWidth);
				nodeDOM.style.minWidth = px(nodeTextDOM.getBoundingClientRect().width / scale);
			}
		}
	});
	nodeDOM.appendChild(dragHandleDOM);
};
